import type { IHubspotSourceKey } from './constants'

/**
 * One mapped HubSpot property, while it is being edited.
 *
 * Held as a list rather than the `property -> expression` record that is saved, so a half-typed or
 * renamed property keeps its place in the table instead of jumping or colliding as it is typed.
 */
export interface IMappingRow {
  property: string
  expression: string
  /** The expression is written by hand rather than picked from the catalog. */
  custom: boolean
}

export const rowsFromRecord = (
  record: Record<string, string>,
  sourceKeys: Record<string, IHubspotSourceKey>,
): IMappingRow[] =>
  Object.keys(record || {}).map((property) => ({
    property,
    expression: record[property],
    custom: !sourceKeys[record[property]],
  }))

/**
 * Blank rows are dropped and the lower of two rows naming one property wins, which is what the
 * server stores either way, so the table shows the mapping that will actually be sent.
 */
export const recordFromRows = (rows: IMappingRow[]): Record<string, string> => {
  const record: Record<string, string> = {}
  rows.forEach(({ property, expression }) => {
    const name = (property || '').trim()
    const source = (expression || '').trim()
    if (name && source) record[name] = source
  })
  return record
}
